export class ItemChecklist {
  Id: number;
  Descricao:string = "";
  ChecklistId: number;
  Ordem: number = 0;
  Observacao:string = "";
}
